import { v4 as uuid } from 'uuid'
import { EntityTypeEnum } from 'common/enums/entityTypeEnum'
import { MasterBlockId } from 'common/types/entities/EntityInterface'
import { SurveyInterface } from 'common/types/entities/SurveyInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createSurvey(
  parentId: string,
  masterBlockId?: MasterBlockId,
): SurveyInterface {
  return {
    ...generateBaseEntity(EntityTypeEnum.Survey, parentId, masterBlockId),
    type: EntityTypeEnum.Survey,
    childIds: [],
    answerBackgroundColor: 'rgba(240,244,248, 1)',
    answerBorder: {
      radius: 25,
    },
    answerColor: 'rgba(93 , 100, 110, 1)',
    answerFontSize: 18,
    answerOutlineColor: 'rgba(20,158,252,1)',
    mobileQuestionTitleFontSize: 26,
    questionSubTitleColor: 'rgba(139, 146, 156, 1)',
    questionSubTitleFontSize: 16,
    questionTitleColor: 'rgba(20, 45, 99, 1)',
    questionTitleFontSize: 30,
    questions: [
      {
        id: uuid(),
        title: 'Add Your SurveyQuestionType Here',
        subTitle: 'Add a description to your question here',
        answers: [
          { id: uuid(), title: 'Answer 1' },
          { id: uuid(), title: 'Answer 2' },
          { id: uuid(), title: 'Answer 3' },
        ],
      },
    ],
    padding: {
      paddingTop: 15,
      paddingRight: 100,
      paddingBottom: 15,
      paddingLeft: 100,
    },
    mobilePadding: {
      paddingTop: 15,
      paddingRight: 15,
      paddingBottom: 15,
      paddingLeft: 15,
    },
  } as SurveyInterface
}
